import {ID} from '~/lib/model';

export const appAdsLinks = {
    missingLines: () => '/app-ads/missing-lines',
    mismatchedLines: () => '/app-ads/mismatched-lines',
    appAds: (sellerId?: ID) => sellerId ? `/app-ads/file/sellerId=${sellerId}` : '/app-ads/file',
    downloadHistory: () => '/app-ads/download-history',
    main: () => '/app-ads'
};
